import { render, staticRenderFns } from "./myLive.vue?vue&type=template&id=830ef13e&scoped=true&"
import script from "./myLive.vue?vue&type=script&lang=js&"
export * from "./myLive.vue?vue&type=script&lang=js&"
import style0 from "./myLive.vue?vue&type=style&index=0&id=830ef13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830ef13e",
  null
  
)

export default component.exports